<template>
    <v-card
        flat
        tile
        class="timelineItem theme-highlight theme-border-inverse"
        :style="{'pointer-events': 'none'}"
    >
        <v-card flat tile class="transparent d-flex flex-nowrap align-center" min-height="26">
            <v-card flat tile class="timeItem-action transparent theme-title">{{item.label}}</v-card>
        </v-card>
    </v-card>
</template>

<script>
    export default {
        name: 'TimelinePeriod',
        props: {
            item: Object
        },
    }
</script>

<style scoped>
    .timelineItem {
        padding: 10px;
        border-width: 1px;
        border-style: solid;
    }

    .timeItem-action {
        font-size: 14px;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        white-space: nowrap;
    }
</style>
